import React from "react";
import { Outlet } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

import { useCurrentUserRoleNames } from "components/RequirePermission/useAccessPermissions";
import UnauthorizedAccess from "components/RequirePermission/UnauthorizedAccess";

// TEMPORARY: while Metered Usage is being rolled out it is limited to Enterprise Admins, on top of the
// metered-usage permissions it already needs. To open it up again, empty this list (or remove the checks that use it).
export const METERED_USAGE_ROLE_NAMES = ["EnterpriseAdmin"];

// null while the roles are still loading.
export const useCanSeeMeteredUsage = () => {
  const roleNames = useCurrentUserRoleNames();
  if (!METERED_USAGE_ROLE_NAMES.length) return true;
  if (roleNames === null || roleNames === undefined) return null;
  return Array.isArray(roleNames) && roleNames.some((name) => METERED_USAGE_ROLE_NAMES.includes(name));
};

// Wraps the Metered Usage routes, so the address can't be typed in either.
export const RequireMeteredUsageAccess = () => {
  const allowed = useCanSeeMeteredUsage();
  if (allowed === null) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", padding: "4rem" }}>
        <CircularProgress size={28} />
      </Box>
    );
  }
  if (!allowed) return <UnauthorizedAccess message="Metered Usage is not available to your role yet." />;
  return <Outlet />;
};
